module.exports = __webpack_public_path__ + "static/media/Lesson-12-9-Faith-and-Obedience.7b7f4679.pdf";